export default {
  setUserAddress(state, address) {
    state.userAddress = address
  },
  setProvinces(state, province) {
    state.provinces = province
  },
  setCities(state, city) {
    state.cities = city
  },
  setDistrict(state, district) {
    state.districts = district
  },
  setNearByAddress(state, address) {
    state.nearby = address
  },
  setSearchAddress(state, address) {
    state.searchAddress = address
  },
  setHotCity(state, hot) {
    state.hotCity = hot
  }
}
